import React, { useState } from 'react';
import { Button, Modal, Table, Form, Row, Col, Breadcrumb } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Link } from "react-router-dom";
import axios from "axios";

import Select from 'react-select';
import { ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DatePicker, DatePickerInput } from "rc-datepicker";
import * as moment from "moment";
import "moment/min/moment-with-locales";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Input } from "semantic-ui-react";
import ReactTable from "react-table";
import "react-table/react-table.css"; 
import _ from "lodash";

//const configData= require('config');
const configData = require( '../../config.json');

const initialValues = {
    weight: '',
    height: '',
    date: ''
   
}
export default class ServicesActivityList extends React.Component  {

    constructor(...args) {
        super(...args)

        this.state = {
            show: false,            
            serviceActivityName:'',
            serviceActivityDesc:'',
            serviceActivityCode:'',
            predecessor:'',
            serviceActivityType:'',
            level:'',
            status:'',
            start_date:'',
            end_date:'',
            _id:undefined,
            serviceactivityfiles: [], 
            // serviceareafiles: [],           
            columns:[],
            originalserviceactivityfiles:[],
            searchInput: "",
            filteredData: [],
            serviceAreaList:[],
            chkisactive:true,           
            userrole:{create:''}
        }
        this.setState({Labels:[], isFetching: true});
        this.fetchLabelMessagesAPI();

    }
     componentDidMount() {
     
        this.fetchServiceActivityListAPI();
        this.getColumns();
        //load service area records 
         this.fetchServiceAreaListAPI();
    }

    getColumns = () => {
        var rolelist= JSON.parse(localStorage.getItem("rolelocation"));
        console.log(rolelist);
        var primaryroleval=  localStorage.getItem("primaryrolesession");
        var selectedrolelocation=undefined;
        _.forEach(rolelist, function(value) {
             
            if(primaryroleval==value.name){
                selectedrolelocation=value;
            }
            
        });
       
        var userrl =_.find(selectedrolelocation.location, function(obj) {
            return obj.location === 'Services';
        });
        let columns = [
          {
            Header: "Activity Name",
            accessor: "serviceActivityName",
            sortable: true,
            show: true,
            displayValue: " Service Activity Name" 
          },
          {
            Header: "Predecessor",
            accessor: "predecessor",
            sortable: true,
            show: true,
            displayValue: "predecessor",
            Cell:row=>(<span>{row.original.predecessor}</span>)
          },
          {
            Header: "Activity Description",
            accessor: "serviceActivityDesc",
            sortable: true,
            show: true,
            displayValue: "Service Activity Desc",
            Cell:row=>(<span>{row.original.serviceActivityDesc.length > 30 ?
                `${row.original.serviceActivityDesc.substring(0, 30)}...` : row.original.serviceActivityDesc} </span>)
          },
          {
            Header: "Activity Code",
            accessor: "serviceActivityCode",
            sortable: true,
            show: true,
            displayValue: " serviceCode "
          },
          {
            Header: "Activity Type",
            accessor: "serviceActivityType",
            sortable: true,
            show: true,
            displayValue: " Service Activity Type"
          },
          {
            Header: "Level",
            accessor: "level",
            sortable: true,
            show: true,
            displayValue: " level ",
            maxWidth: 100,
            minWidth: 50,
            width: 50,
            Cell: row => <div style={{ textAlign: "right" }}>{row.value}</div>
          },     
          {
            Header: "Start Date",
            accessor: "start_date",
            sortable: true,
            show: true,
            displayValue: "start_date",
            maxWidth: 100,
            minWidth: 90,
            width: 90,
            Cell: row => <div style={{ textAlign: "center" }}>{row.value}</div>
          },
          {
            Header: "End Date",
            accessor: "end_date",
            sortable: true,
            show: true,
            displayValue: "end_date",
            maxWidth: 100,
            minWidth: 90,
            width: 90,
            Cell: row => <div style={{ textAlign: "center" }}>{row.value}</div>
          },
          
          {
            Header: "Status",
            accessor: "status",
            sortable: true,
            show: true,
            displayValue: "status",
            maxWidth: 100,
            minWidth: 56,
            width: 56,
            Cell: row => <div style={{ textAlign: "center" }}>{row.value}</div>
          },
          {
            Header:"Edit",
            maxWidth: 100,
            minWidth: 40,
            width: 40,
            show:userrl.edit=='Y'?true:false,
            Cell:row => (<div className="grdbuttoncontainer"><div className="editcontainer"> <a
                className="editbutton"
                aria-label="Edit"
                onClick={(event) => this.handleEditClick(row,event)}
            >
                <i className="">
                    <img
                        alt="Edit"
                        className=""
                        src="/images/edit_icon.png"
                    />
                </i>
            </a></div></div>)
          }, 
          {
            Header:"Delete",
            maxWidth: 100,
            minWidth: 58,
            width: 58,
            show:userrl.delete=='Y'?true:false,
            Cell:row => (<div className="grdbuttoncontainer"><div className="deletecontainer"> <a
                className="deletebutton"
                aria-label="Delete"
                onClick={(event) => this.handleDeleteClick(row,event)}
            >
                <i className="">
                    <img
                        alt="Delete"
                        className=""
                        src="/images/delete_icon.png"
                    />
                </i>
            </a></div></div>)
          }
        ];
        this.setState({ columns });
      };

    fetchServiceActivityListAPI = () => {
        this.setState({...this.state, isFetching: true});
        if(localStorage.getItem("session")==undefined || localStorage.getItem("session")=="undefined"){
            this.props.history.push("/login");
        }
        else{
        var cookie_value= JSON.parse(localStorage.getItem("session")).key;
        var userId= JSON.parse(localStorage.getItem("session")).Result[0]._id;
        axios
        .get(configData.SERVER_URL+`fincorp_getServiceActivityList` 
        , {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",

                "Authorization": `Bearer ${cookie_value}||${userId} `
            }
        })
        .then(
            res=>  {this.setServiceActivityList(res.data) }
        )
        .catch(err => {
            console.log("AXIOS ERROR: ", err);
        });
    }
    };

    setServiceActivityList=(result)=>{
        var rolelist= JSON.parse(localStorage.getItem("rolelocation"));
        console.log(rolelist);
        var primaryroleval=  localStorage.getItem("primaryrolesession");
        var selectedrolelocation=undefined;
        _.forEach(rolelist, function(value) {
             
            if(primaryroleval==value.name){
                selectedrolelocation=value;
            }
            
        });
       
        var userrl =_.find(selectedrolelocation.location, function(obj) {
            return obj.location === 'Services';
        });
        if(result!="No document(s) found with defined find criteria!" && result!=null &&result.length>0){
            this.setState({serviceactivityfiles: result, originalserviceactivityfiles:result,userrole: userrl, isFetching: false});
            this.globalSearch();
        }
        else
         this.setState({...this.state,userrole: userrl, isFetching: false})
        

    }

    fetchServiceAreaListAPI = () => {
        //this.setState({...this.state, isFetching: true});
        if(localStorage.getItem("session")==undefined || localStorage.getItem("session")=="undefined"){
            this.props.history.push("/login");
        }
        else{
        var cookie_value= JSON.parse(localStorage.getItem("session")).key;
        var userId= JSON.parse(localStorage.getItem("session")).Result[0]._id;
        axios
        .get(configData.SERVER_URL+`fincorp_getServiceAreaList` 
        , {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",

                "Authorization": `Bearer ${cookie_value}||${userId} `
            }
        })
        .then(
            res=>  {this.setServiceAreaList(res.data) }
        )
        .catch(err => {
            console.log("AXIOS ERROR: ", err);
        });
    }
    };

    setServiceAreaList=(result)=>{
        
        if(result.Message=='Invalid Session'){
            this.props.history.push("/login")
        }
        if(result!="No document(s) found with defined find criteria!" && result!=null &&result.length>0){
            
            this.setState({serviceAreaList: result, isFetching: false});
            //   }));
        }    
    }
  
     handleChange = e => {
        let { value, name } = e.target;       
        const date = new Date().toLocaleString().split(',')[0];
        this.setState({
            ...this.state,
            [name]: value,
            date
        });
    };
    
    handleAddMember=()=>{
        this.state.serviceActivityName = '';
        this.state.serviceActivityDesc ='';
        this.state.start_date = '';
        this.state.end_date = '';
        this.state.serviceActivityCode = '';
        this.state.predecessor = '';
        this.state.serviceActivityType = '';
        this.state.level = '';
        this.state.status = '';

        this.state._id = undefined;
        this.setState({show: true, editshow:false });
    }
    handleClose=()=> {
        this.state.serviceActivityName = '';
        this.state.serviceActivityDesc ='';
        this.state.start_date = '';
        this.state.end_date = '';
        this.state.serviceActivityCode = '';
        this.state.predecessor = '';
        this.state.serviceActivityType = '';
        this.state.level = '';
        this.state.status = '';

        this.state._id = undefined;
        this.setState({ show: false });
    }
  
    handleClick = () => {
        this.change(this.state);
        this.setState(initialValues);
    };

    handleEditClick = (row,event) => {
        this.state.serviceActivityName = row.original.serviceActivityName;
        this.state.serviceActivityDesc = row.original.serviceActivityDesc;
        this.state.start_date = row.original.start_date;
        this.state.end_date = row.original.end_date;
        this.state.serviceActivityCode = row.original.serviceActivityCode;
        this.state.predecessor = row.original.predecessor;
        var predecessorval=undefined;
        
           _.forEach(this.state.serviceAreaList, function(value) {
             
            if(row.original.predecessor==value.serviceAreaName){
               predecessorval=value;
            }
        });
        this.state.predecessor ={'label':predecessorval.serviceAreaName,'value':predecessorval._id};

        this.state.serviceActivityType = row.original.serviceActivityType;
        this.state.level = row.original.level;
        this.state.status = row.original.status;

        this.state._id = row.original._id;
        this.setState({ show: true, editshow: false});
       // this.props.history.push("/Item?id=" + row.id);
    };

     editImgFormatter = (cell, row) => {              
        return (
            <a
                className="editbutton"
                aria-label="Edit"
                onClick={() => this.handleEditClick(row)}
            >
                <i className="">
                    <img
                        alt="Edit"
                        className=""
                        src="/images/edit_icon.png"
                    />
                </i>
            </a>
        );
    }

     deleteImgFormatter = (cell, row) => {              
        return (
            <a
                className="deletebutton"
                aria-label="Delete"
                onClick={() => this.handleDeleteClick(row)}
            >
                <i className="">
                    <img
                        alt="Delete"
                        className=""
                        src="/images/delete_icon.png"
                    />
                </i>
            </a>
        );
    }

    handleDeleteClick = (row,event) => {
        if(window.confirm('Are you sure to delete this record?')){ 
        //delete
        if (row.original._id!= undefined) {
            axios
                .post(configData.SERVER_URL + `fincorp_deleteServiceActivity`,

                    { '_id': row.original._id }
                    , {
                        headers: {
                            "Content-Type": "application/json;charset=UTF-8",
                            "Access-Control-Allow-Origin": "*"
                        }
                    })
                .then(
                    res => this.reloadDataGrid(res.data)
                )
                .catch(err => {
                    console.log("AXIOS ERROR: ", err);
                });
        }
        else {
            //error            
            toast.warn("Service Activity Not Deleted");
        }
    }
    }
    reloadDataGrid = (res) => {

        toast.success("Service Activity  Deleted Successfully");
        setTimeout(this.fetchServiceActivityListAPI(), 4000);
    }

    onStartDateChange = (jsDate, dateString) => {
        this.setState(prevState => ({
           
                // object that we want to update
                ...prevState, // keep all other key-value pairs
                
                start_date: moment(dateString).format("MM-DD-YYYY")
                
           
        }));
    };
    onEndDateChange = (jsDate, dateString) => {
        this.setState(prevState => ({
           
                // object that we want to update
                ...prevState, // keep all other key-value pairs
                
                end_date: moment(dateString).format("MM-DD-YYYY")
                
           
        }));
    };

    handleSaveClick = (event) => {
        const regServiceCode= /^[a-zA-Z0-9.-]*$/;
        

        if (this.state.serviceActivityName == undefined || this.state.serviceActivityName == "" || this.state.serviceActivityName.length == 0) {
           toast.warn("Enter Service Activity Name");
           event.preventDefault();
       }       
       else if (this.state.serviceActivityDesc == undefined || this.state.serviceActivityDesc == "") {
           toast.warn("Enter Service Activity Desc");
           event.preventDefault();
       }

       else if (this.state.serviceActivityCode == undefined || this.state.serviceActivityCode == "") {
        toast.warn("Enter Service Activity Code");
        event.preventDefault();
        }
        else if (regServiceCode.test(this.state.serviceActivityCode) === false){
        toast.warn("Service Activity Code Must Contain Only Alphanumeric");
        event.preventDefault();        
        }
        else if (this.state.serviceActivityType == undefined || this.state.serviceActivityType == "") {
        toast.warn("Choose Service Activity Type");
        event.preventDefault();
        }
         else if (this.state.level == undefined || this.state.level == "") {
        toast.warn("Enter Service Activity Level");
        event.preventDefault();
        }
        else if (this.state.predecessor == undefined || this.state.predecessor == "") {
        toast.warn("Enter Service Activity Predecessor");
        event.preventDefault();
        }
        else if (this.state.start_date == undefined || this.state.start_date == "" || this.state.start_date == "Invalid date") {
        toast.warn("Enter StartDate");
        event.preventDefault();
        }
       
       else if (Date.parse(this.state.start_date) > Date.parse(this.state.end_date)) {
           toast.warn("End Date should be greater than the StartDate");
           event.preventDefault();
       }     
       else if (this.state.status == undefined || this.state.status == "") {
           toast.warn("Choose Status");
           event.preventDefault();


       }
       else {
           
        this.state.start_date=  this.state.start_date == "Invalid date"?null:this.state.start_date;
        this.state.end_date=  this.state.end_date == "Invalid date"?null:this.state.end_date;

           if (this.state._id!= undefined) {
            //this.state.start_date=  this.state.start_date == "Invalid date"?null:this.state.start_date;
            //this.state.end_date=  this.state.end_date == "Invalid date"?null:this.state.end_date;
            if(window.confirm('Do you want to save changes?')){ 
               axios
                   .post(configData.SERVER_URL + `fincorp_updateServiceActivity`,

                       { '_id': this.state._id, 'serviceActivityName': this.state.serviceActivityName, 
                       'serviceActivityDesc': this.state.serviceActivityDesc,
                        'serviceActivityCode': this.state.serviceActivityCode, 
                        'predecessor': this.state.predecessor.label,
                        'serviceActivityType':this.state.serviceActivityType,
                        'level':this.state.level,
                         'start_date': this.state.start_date, 
                         'end_date': this.state.end_date,
                          'status': this.state.status }
                       , {
                           headers: {
                               "Content-Type": "application/json;charset=UTF-8",
                               "Access-Control-Allow-Origin": "*"
                           }
                       })
                   .then(
                       res =>  this.UpdateChanges(res.data) 


                   )
                   .catch(err => {
                       console.log("AXIOS ERROR: ", err);
                   });
                }

           }
           else {
               
               axios
                   .post(configData.SERVER_URL + `fincorp_insertServiceActivity`,

                       { 'serviceActivityName': this.state.serviceActivityName, 
                       'serviceActivityDesc': this.state.serviceActivityDesc,
                       'serviceActivityCode': this.state.serviceActivityCode, 
                       'predecessor': this.state.predecessor.label,
                       'serviceActivityType':this.state.serviceActivityType,
                       'level':this.state.level,
                       'start_date': this.state.start_date, 
                       'end_date': this.state.end_date,
                       'status': this.state.status}
                       , {
                           headers: {
                               "Content-Type": "application/json;charset=UTF-8",
                               "Access-Control-Allow-Origin": "*"
                           }
                       })
                   .then(
                       res => this.SaveChanges(res.data) 
                   )
                   .catch(err => {
                       console.log("AXIOS ERROR: ", err);
                   });

           }

       }
   };

   SaveChanges = (res) => {
    if(res.MessageKey!=undefined){
        toast.warn(res.Message);
    }
    else{
    toast.success("Service Activity Inserted Successfully");
    setTimeout( this.fetchServiceActivityListAPI(),4000);
    this.setState({ show: false, editshow: false });
    }
}
UpdateChanges = (res) => {
    if(res.MessageKey!=undefined){
        toast.warn(res.Message);
    }
    else{
   toast.success("Service Activity Updated Successfully");
   setTimeout( this.fetchServiceActivityListAPI(),4000);
   this.state.serviceActivityName = '';
   this.state.serviceActivityDesc ='';
   this.state.start_date = '';
   this.state.end_date = '';
   this.state.serviceActivityCode = '';
   this.state.predecessor = '';
   this.state.serviceActivityType = '';
   this.state.level = '';
   this.state.status = '';

   this.state._id = undefined;

   this.setState({ show: false, editshow: false });
    }
}

    fetchLabelMessagesAPI = () => {
        this.setState({...this.state, isFetching: true});
        
        axios
        .get(configData.SERVER_URL+`fincorp_getCustomMessage` 
        , {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*"
            }
        })
        .then(
            res=>  {this.setBindMessage(res.data) }
        )
        .catch(err => {
            console.log("AXIOS ERROR: ", err);
        });
    };

    setBindMessage=(result)=>{
        
        if(result!="No document(s) found with defined find criteria!" && result!=null &&result.length>0){
            
            this.setState({Labels: result, isFetching: false});
        }      
    }

    handleSelectChangeArea = (selectedOption) => {
        this.setState(prevState => ({
                   ...prevState,  
                   predecessor: selectedOption
             
        }));
        
      };

    handleChange1 = event => {
        this.setState({ searchInput: event.target.value }, () => {
          this.globalSearch();
        });
      };

      toggleChange = () => {
        this.setState({
            chkisactive: !this.state.chkisactive,
        });
        this.globalActiveSearch(!this.state.chkisactive) ;
      }

      globalActiveSearch = (param) => {
        let { searchInput } = this.state;       
        let filteredData = this.state.originalserviceactivityfiles.filter(value => {
            if(param){

                return (
                    (value.serviceActivityName.toLowerCase().includes(searchInput.toLowerCase()) ||
                    value.serviceActivityDesc.toLowerCase().includes(searchInput.toLowerCase()) ||
                    value.serviceActivityCode.toString().toLowerCase().includes(searchInput.toLowerCase())||
                    value.serviceActivityType.toString().toLowerCase().includes(searchInput.toLowerCase())||
                    value.level.toString().toLowerCase().includes(searchInput.toLowerCase())||
                     value.predecessor.toLowerCase().includes(searchInput.toLowerCase())||
                    value.start_date.toLowerCase().includes(searchInput.toLowerCase()) ||
                    ( value.end_date!=undefined||value.end_date!=null? value.end_date.toString().toLowerCase().includes(searchInput.toLowerCase()):''))&&                                        
                    value.status.toString().includes('Active')  
                   
                );

            }else{
                return (
                    value.serviceActivityName.toLowerCase().includes(searchInput.toLowerCase()) ||
                    value.serviceActivityDesc.toLowerCase().includes(searchInput.toLowerCase()) ||
                    value.serviceActivityCode.toString().toLowerCase().includes(searchInput.toLowerCase())||
                    value.serviceActivityType.toString().toLowerCase().includes(searchInput.toLowerCase())||
                    value.level.toString().toLowerCase().includes(searchInput.toLowerCase())||
                     value.predecessor.toLowerCase().includes(searchInput.toLowerCase())||
                    value.start_date.toLowerCase().includes(searchInput.toLowerCase()) ||
                    ( value.end_date!=undefined||value.end_date!=null? value.end_date.toString().toLowerCase().includes(searchInput.toLowerCase()):'') ||                
                    value.status.toString().toLowerCase().includes(searchInput.toLowerCase())
                );
        }
        });
        this.setState({ serviceactivityfiles: filteredData });
      };

      globalSearch = () => {
        let { searchInput } = this.state;
        let filteredData = this.state.originalserviceactivityfiles.filter(value => {
         if(this.state.chkisactive){   
          return (
            (value.serviceActivityName.toLowerCase().includes(searchInput.toLowerCase()) ||
            value.serviceActivityDesc.toLowerCase().includes(searchInput.toLowerCase()) ||
            value.serviceActivityCode.toString().toLowerCase().includes(searchInput.toLowerCase())||
            value.serviceActivityType.toString().toLowerCase().includes(searchInput.toLowerCase())||
            value.level.toString().toLowerCase().includes(searchInput.toLowerCase())||
             value.predecessor.toLowerCase().includes(searchInput.toLowerCase())||
            value.start_date.toLowerCase().includes(searchInput.toLowerCase()) ||
            ( value.end_date!=undefined||value.end_date!=null? value.end_date.toString().toLowerCase().includes(searchInput.toLowerCase()):''))&&                                        
            value.status.toString().includes('Active')
          );
         }else{
            return (
                value.serviceActivityName.toLowerCase().includes(searchInput.toLowerCase()) ||
                value.serviceActivityDesc.toLowerCase().includes(searchInput.toLowerCase()) ||
                value.serviceActivityCode.toString().toLowerCase().includes(searchInput.toLowerCase())||
                value.serviceActivityType.toString().toLowerCase().includes(searchInput.toLowerCase())||
                value.level.toString().toLowerCase().includes(searchInput.toLowerCase())||
                 value.predecessor.toLowerCase().includes(searchInput.toLowerCase())||
                value.start_date.toLowerCase().includes(searchInput.toLowerCase()) ||
                ( value.end_date!=undefined||value.end_date!=null? value.end_date.toString().toLowerCase().includes(searchInput.toLowerCase()):'') ||                
                value.status.toString().toLowerCase().includes(searchInput.toLowerCase())
            ); 
         }
        });
        this.setState({ serviceactivityfiles: filteredData });
      };

    render() {
        const Labels=this.state.Labels!=null&& this.state.Labels!=undefined?this.state.Labels:[];
        let { data, columns, searchInput } = this.state; 
        const optionsAreaArray =this.state.serviceAreaList!=null&& this.state.serviceAreaList!=undefined? this.state.serviceAreaList:[]; 
       

    return (
        <>
            <div className="container userinfo-container" role="main">
                {/* <Breadcrumb>
                    <Breadcrumb.Item>
                        <Link to="/Home">Home </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to="/serviceshome">Services Home </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                        Services Activity List
                    </Breadcrumb.Item>
                </Breadcrumb> */}
                <div className="centeralign">
                <span className="mainheadings">
                    {Labels.filter(lbl => lbl.keyPair=='ServiceActivityList_Title' && lbl.pageName=='ServiceActivityList').map(filteredPerson => (
                        <span>
                        {filteredPerson.keyValue}
                        </span>
                    ))}
                </span>
                </div>
                <div className="fullwidth">
                    <div className="float-left">

                    <button className={this.state.userrole.create=='Y'?"btn btn-primary  float-left ":"hidden"}  onClick={this.handleAddMember} > 
                    {Labels.filter(lbl => lbl.keyPair=='ServiceActivityList_Addbtn' && lbl.pageName=='ServiceActivityList').map(filteredPerson => (
                        <span>
                        {filteredPerson.keyValue}
                        </span>
                    ))}
                    </button>
                    </div>
                    <div className="float-right">
                    <div className="isactivecontainer" >
                            <span>Active</span>
                            <input type="checkbox" aria-label="Status Filter" className="chkisactive"
                            defaultChecked={this.state.chkisactive}
                            onChange={this.toggleChange}
                            />                            
                        </div>
                        <div className="float-left txtsearchcontainer">
                        <span className="searchlabel">
                        {Labels.filter(lbl => lbl.keyPair=='ServiceActivityList_Search' && lbl.pageName=='ServiceActivityList').map(filteredPerson => (
                            <span>
                            {filteredPerson.keyValue}
                            </span>
                        ))}
                        </span>
                        <Form.Control
                            aria-label="search"
                            type="text"
                            name="search"
                            value={searchInput || ""}
                            onChange={this.handleChange1}
                        />
                        </div>
                    </div>
                   
                </div>
                <div className="fullwidth row m0">
                <div className="col-md-12 mt-10 p0">
                     <ReactTable
                    data={this.state.serviceactivityfiles}
                    columns={this.state.columns}
                    defaultPageSize={20}
                    className="-striped -highlight fullwidth"
                    />  
                </div>      
               </div>
                <div className="row col-md-12 m0 p0">
                    {/* <BootstrapTable
                        data={this.state.serviceactivityfiles}
                        striped
                        hover
                        condensed
                        pagination={true}
                        insertRow
                        deleteRow
                        search                       
                        tableHeaderClass="my-header-class"
                        tableBodyClass="my-body-class"
                        containerClass="my-container-class"
                        tableContainerClass="my-table-container-class"
                        headerContainerClass="usersystem-grid-header-container-class"
                        bodyContainerClass="my-body-container-class"
                    >
                        <TableHeaderColumn dataField="serviceActivityName" width="16%" isKey dataSort>
                            Service Activity Name
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="serviceActivityDesc" width="14%" >
                            Service Activity Desc
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="serviceActivityCode" width="10%" >
                            Service Activity Code
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="serviceActivityType" width="10%" >
                            Service Activity Type
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="level" width="6%" >
                            Level
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="predecessor" width="8%" >
                            Predecessor
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="start_date" width="10%" dataAlign="center">
                            Start Date
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="end_date" width="10%" dataAlign="center">
                            End Date
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="status" width="6%">
                            Status
                        </TableHeaderColumn>
                        <TableHeaderColumn dataAlign="edit" width="5%" dataFormat={this.editImgFormatter} dataAlign="center">
                                Edit
                        </TableHeaderColumn>
                            <TableHeaderColumn dataAlign="delete" width="5%" dataFormat={this.deleteImgFormatter} dataAlign="center">
                                Delete
                        </TableHeaderColumn>
                    </BootstrapTable> */}
                    {/* <div className="row col-md-12">
                    <div className="fullwidth"> 
                    <Link to="/serviceshome" className="btn btn-secondary float-right  ml-10">Cancel</Link>                  
                    <Link to="/view" className="btn btn-info float-right">View</Link>                
                    </div> 
                    </div> */}
                </div>               
                <div>
                <Modal
                        className="ServicesActivity-modal"
                         show={this.state.show}
                         onHide={this.handleClose}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title className="margin_auto">
                            {Labels.filter(lbl => lbl.keyPair=='ServiceActivity_Title' && lbl.pageName=='ServiceActivity').map(filteredPerson => (
                                <span>
                                 {this.state._id==undefined?"Add":"Edit"} {filteredPerson.keyValue}
                                </span>
                            ))}                            
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <Form>
                    
                    <Form.Row>
                        <Row className="margin-t10 col-md-12">
                            <Col md={6} className="row">
                            <Col md={4}>
                                    <Form.Label className="required" for="frmactivityename">
                                    {Labels.filter(lbl => lbl.keyPair=='ServiceActivity_Name' && lbl.pageName=='ServiceActivity').map(filteredPerson => (
                                <span>
                                    {filteredPerson.keyValue}
                                </span>
                            ))}
                                    </Form.Label>{" "}
                                </Col>
                                <Col md={8}>
                                    <Form.Control
                                        id="frmactivityename"
                                        type="text"
                                        name="serviceActivityName"
                                        placeholder="Activity Name"
                                        disabled={this.state._id!=undefined?true:false}
                                        value={this.state.serviceActivityName}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Col>
                            <Col md={6} className="row">
                                <Col md={4}>
                                <Form.Label className="required" for="frmdescr">
                                {Labels.filter(lbl => lbl.keyPair=='ServiceActivity_Desc' && lbl.pageName=='ServiceActivity').map(filteredPerson => (
                                <span>
                                    {filteredPerson.keyValue}
                                </span>
                            ))} 
                                </Form.Label>{" "}
                                </Col>
                                <Col md={8}>   
                                <Form.Control
                                            id="frmdescr"
                                            className="desc-width"
                                            as="textarea"
                                            rows="1"
                                            name="serviceActivityDesc"
                                            placeholder="Description"
                                            value={this.state.serviceActivityDesc}
                                            onChange={this.handleChange}
                                            className="required"
                                            
                                        />
                                </Col>
                            </Col>


                        </Row>
                    </Form.Row>
                    <Form.Row>
                        <Row className="margin-t10 col-md-12">                           
                        <Col md={6} className="row">
                                <Col md={4}>
                                    <Form.Label className="required" for="frmactivitycode">
                                    {Labels.filter(lbl => lbl.keyPair=='ServiceActivity_Code' && lbl.pageName=='ServiceActivity').map(filteredPerson => (
                                <span>
                                    {filteredPerson.keyValue}
                                </span>
                            ))}
                                    </Form.Label>
                                </Col>
                                <Col md={8}>
                                    <Form.Control
                                        id="frmactivitycode"
                                        type="text"
                                        className="form-control"
                                        controlId="activitycode"
                                        name="serviceActivityCode"
                                        placeholder="Activity Code"
                                        onChange={this.handleChange}
                                        disabled={this.state._id!=undefined?true:false}
                                        value={this.state.serviceActivityCode}
                                        required
                                    >
                                    </Form.Control>
                                </Col>
                            </Col>
                            <Col md={6} className="row" >
                                <Col md={4}>
                                    <Form.Label className="required" for="frmactivitytype">
                                    {Labels.filter(lbl => lbl.keyPair=='ServiceActivity_Type' && lbl.pageName=='ServiceActivity').map(filteredPerson => (
                                        <span>
                                            {filteredPerson.keyValue}
                                        </span>
                                    ))}
                                    </Form.Label>{" "}
                                </Col>
                                <Col md={8}>
                                    <Form.Control
                                        id="frmactivitytype"
                                        as="select"
                                        name="serviceActivityType"                                        
                                        value={this.state.serviceActivityType}
                                        onChange={this.handleChange}
                                    >
                                        
                                        <option value="">Select Type</option>    
                                        <option value="Primary">Primary</option>
                                        <option value="Secondary">Secondary</option>
                                    </Form.Control>
                                </Col>
                            </Col>  
                        </Row>
                    </Form.Row>
                    <Form.Row>
                        <Row className="margin-t10 col-md-12">   
                        <Col md={6} className="row">
                                <Col md={4}>
                                    <Form.Label className="required" for="frmactivitylevel">
                                    {Labels.filter(lbl => lbl.keyPair=='ServiceActivity_Level' && lbl.pageName=='ServiceActivity').map(filteredPerson => (
                                        <span>
                                            {filteredPerson.keyValue}
                                        </span>
                                    ))}
                                    </Form.Label>{" "}
                                </Col>
                                <Col md={8}>
                                    <Form.Control
                                        id="frmactivitylevel"
                                        type="number"
                                        name="level"
                                        placeholder="Activity Level"                                        
                                        value={this.state.level}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </Col>                           
                        <Col md={6} className="row">
                                <Col md={4}>
                                    <Form.Label className="required" for="frmactivitypredecessor">
                                    {Labels.filter(lbl => lbl.keyPair=='ServiceActivity_Predecessor' && lbl.pageName=='ServiceActivity').map(filteredPerson => (
                                        <span>
                                            {filteredPerson.keyValue}
                                        </span>
                                    ))}   
                                    </Form.Label>
                                </Col>
                                <Col md={8}>                                    
                                    <Select
                                    name="serviceArea"
                                    value={this.state.predecessor}
                                    onChange={this.handleSelectChangeArea}
                                     
                                    options={optionsAreaArray.map(opt => ({ label: opt.serviceAreaName, value: opt._id }))}
                                    />
                                </Col>
                            </Col>

                              
                        </Row>
                    </Form.Row>      
                    <Form.Row>
                        <Row className="mt-10">
                            <Col md={6} className="row">
                                <Col md={4}>
                                    <Form.Label className="required">
                                    {Labels.filter(lbl => lbl.keyPair=='ServiceActivity_StartDate' && lbl.pageName=='ServiceActivity').map(filteredPerson => (
                                        <span>
                                            {filteredPerson.keyValue}
                                        </span>
                                    ))}
                                    </Form.Label>{" "}
                                </Col>
                                <Col md={8}>
                                <DatePickerInput
                                            id="startdate"
                                            name="start_date"
                                            onChange={this.onStartDateChange.bind(this, 'start_date') }
                                             placeholder="MM/DD/YYYY"
                                             value={this.state.start_date}
                                            minDate={moment().toDate()}
                                            className="my-custom-datepicker-component"
                                            aria-label="startdate"
                                            readOnly
                                        />                                       
                                </Col>
                            </Col>
                            <Col md={6} className="row">
                                <Col md={4}>
                                    <Form.Label>
                                    {Labels.filter(lbl => lbl.keyPair=='ServiceActivity_EndDate' && lbl.pageName=='ServiceActivity').map(filteredPerson => (
                                        <span>
                                            {filteredPerson.keyValue}
                                        </span>
                                    ))}
                                    </Form.Label>{" "}
                                </Col>
                                <Col md={8}>                                                                   
                                <DatePickerInput
                                            id="enddate"
                                            name="end_date"
                                             onChange={this.onEndDateChange.bind(this, 'end_date') }
                                            placeholder="MM/DD/YYYY"
                                             value={this.state.end_date}
                                            minDate={moment().toDate()}
                                            className="my-custom-datepicker-component"
                                            aria-label="enddate"
                                            readOnly
                                        />
                                </Col>
                            </Col>
                        </Row>
                    </Form.Row>                 


                    <Form.Row>
                     <Row className="margin-t10 col-md-12">        
                     <Col md={6} className="row" >
                                <Col md={4}>
                                    <Form.Label className="required" for="servicesactivitystatus">
                                    {Labels.filter(lbl => lbl.keyPair=='ServiceActivity_Status' && lbl.pageName=='ServiceActivity').map(filteredPerson => (
                                        <span>
                                            {filteredPerson.keyValue}
                                        </span>
                                    ))}
                                    </Form.Label>{" "}
                                </Col>
                                <Col md={8}>
                                    <Form.Control
                                        id="servicesactivitystatus"
                                        as="select"
                                        name="status"                                       
                                        onChange={this.handleChange}
                                        value={this.state.status}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </Form.Control>
                                </Col>
                            </Col>  
                     </Row>
                    </Form.Row>  
                </Form>
   
                        </Modal.Body>
                            <Modal.Footer>
                               
                                <Button variant="primary" onClick={this.handleSaveClick}>
                                {Labels.filter(lbl => lbl.keyPair=='ServiceActivity_SaveBtn' && lbl.pageName=='ServiceActivity').map(filteredPerson => (
                                        <span>
                                            {filteredPerson.keyValue}
                                        </span>
                                    ))}
                                 </Button>
                                 <Button variant="secondary" onClick={this.handleClose} >
                                 {Labels.filter(lbl => lbl.keyPair=='ServiceActivity_CancelBtn' && lbl.pageName=='ServiceActivity').map(filteredPerson => (
                                        <span>
                                            {filteredPerson.keyValue}
                                        </span>
                                    ))}
                                 </Button>
                            </Modal.Footer>
                    </Modal>                        
                </div>
            </div>



        </>
    );
    }
}

